<template>
  <div>
    <el-row>
      <el-col>
        <el-button @click="createDocument" size="medium" style="margin-top: 20px;">新建周转筐</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="NAME" label="名称" min-width="50"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格（kg/框）" min-width="50"></el-table-column>
          <el-table-column prop="COLOR" label="颜色" min-width="50"></el-table-column>
          <!-- <el-table-column prop="DEST_PROJECT_NAME" label="调入仓库" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_COUNT" label="总数量" min-width="40">
          </el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价值" min-width="40">
          </el-table-column>
          <el-table-column prop="STATUS" label="状态" min-width="60">
            <template slot-scope="scope">
              <el-tag>{{ showStatusLable(scope.row.STATUS) }}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="change(scope.row)">修改</el-button>
              <!-- <el-button type="text" icon="el-icon-view" size="small" @click="del(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
      layout="total,prev, pager, next, jumper" :total="total_count" style="float: right"></el-pagination> -->
    <!-- 新增周转筐 -->
    <el-dialog :visible.sync="addFormDialog" title="新建周转筐" @close="close" width="430px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true" size="small">
        <el-form-item label="名称：" label-width="120px">
          <el-input placeholder="请输入名称" v-model="addForm.turnoverName" label-width="120px"></el-input>
        </el-form-item>
        <el-form-item label="规格：" label-width="120px">
          <!-- oninput ="value=value.replace(/[^0-9.]/g,'')" -->
          <el-input v-model="addForm.turnoverSize" placeholder="请输入规格" style="width:200px"><template slot="append">kg/筐</template></el-input>
        </el-form-item>
        <el-form-item label="颜色： " label-width="120px">
          <el-input v-model="addForm.turnoverColor" placeholder="请输入颜色">
          </el-input>
        </el-form-item>
        <el-form-item label="尺寸： " label-width="120px">
          <el-input v-model="addForm.length" style="width:56px" placeholder="长度" oninput="value=value.replace(/[^0-9.]/g,'')">
          </el-input> x
          <el-input v-model="addForm.width" style="width:57px" placeholder="宽度" oninput="value=value.replace(/[^0-9.]/g,'')">
          </el-input> x
          <el-input v-model="addForm.height" style="width:57px" placeholder="高度" oninput="value=value.replace(/[^0-9.]/g,'')">
          </el-input>
          <div style="color:red">*长宽高单位为：cm</div>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="close">取消</el-button>
        <el-button class="operate-btn" @click="submitAdd">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改周转筐 -->
    <el-dialog title="修改周转筐" width="400px" center :visible.sync="changeVisible" :close-on-click-modal="false">
      <el-form size="small" :inline="true">
        <!-- ---- -->
        <el-form-item label="名称：" label-width="120px">
          <el-input placeholder="请输入名称" v-model="changeInput.NAME" label-width="120px"></el-input>
        </el-form-item>
        <el-form-item label="规格：" label-width="120px">
          <el-input v-model="changeInput.SPECIFICATION" placeholder="请输入规格" style="width:200px" oninput="value=value.replace(/[^0-9.]/g,'')"><template
              slot="append">kg/筐</template></el-input>
        </el-form-item>
        <el-form-item label="颜色： " label-width="120px">
          <el-input v-model="changeInput.COLOR" placeholder="请输入颜色"></el-input>
        </el-form-item>
        <el-form-item label="尺寸： " label-width="120px">
          <el-input v-model="changeInput.LENGTH" style="width:56px" placeholder="长度" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> x
          <el-input v-model="changeInput.WIDTH" style="width:57px" placeholder="宽度" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> x
          <el-input v-model="changeInput.HEIGHT" style="width:57px" placeholder="高度" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          <div style="color:red">*长宽高单位为：cm</div>
        </el-form-item>
        <!--  -->
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="changeVisible = false">取 消</el-button>
        <el-button class="operate-btn" @click="submitChange()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      STATUS_LIST: ['已撤回', '未处理', '已同意'],
      statusList: [
        {
          label: '已撤回',
          value: '0',
        },
        {
          label: '未处理',
          value: '1',
        },
        {
          label: '已同意',
          value: '2',
        },
      ],
      pageSize: 10,
      currentPage: 1,
      PROJECT_LIST: [],
      total_count: 0,
      tableData: [],
      addFormDialog: false,
      addForm: {},
      changeVisible: false,
      changeInput: {},
    };
  },
  methods: {
    showStatusLable(index) {
      return this.STATUS_LIST[index];
    },
    // 修改周转筐
    change(row) {
      this.changeInput = { ...row };
      this.changeVisible = true;
    },
    // 修改周转筐确定按钮
    submitChange() {
      const reg = /(^([1-9]\d*)(.\d+)?$)|(^(0{1})(.\d+){1}$)/;
      if (this.changeInput.NAME == '') {
        this.$message.show({ text: '请输入名称', type: 'warning' });
        return false;
      }
      if (this.changeInput.SPECIFICATION && !reg.test(this.changeInput.SPECIFICATION)) {
        this.$message.show({ text: '规格必须为数字', type: 'warning' });
        return false;
      }
      if (this.changeInput.WIDTH || this.changeInput.HEIGHT || this.changeInput.LENGTH) {
        if (!(this.changeInput.WIDTH && this.changeInput.HEIGHT && this.changeInput.LENGTH)) {
          this.$message.show({ text: '请完整填写长宽高', type: 'warning' });
          return false;
        }
        if (!reg.test(this.changeInput.WIDTH)) {
          this.$message.show({ text: '宽度必须为正数', type: 'warning' });
          return false;
        }
        if (!reg.test(this.changeInput.HEIGHT)) {
          this.$message.show({ text: '高度必须为正数', type: 'warning' });
          return false;
        }
        if (!reg.test(this.changeInput.LENGTH)) {
          this.$message.show({ text: '长度必须为正数', type: 'warning' });
          return false;
        }
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10026',
            OTYPE: 16,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            BASKET_ID: this.changeInput.BASKET_ID,
            NAME: this.changeInput.NAME,
            SPECIFICATION: this.changeInput.SPECIFICATION,
            COLOR: this.changeInput.COLOR,
            WIDTH: this.changeInput.WIDTH,
            HEIGHT: this.changeInput.HEIGHT,
            LENGTH: this.changeInput.LENGTH,
            SIZE_UNIT: 'cm',
          };
          http.post(data).then((res) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            document.body.style.cursor = 'default';
            this.changeVisible = false;
            this.queryTurnover();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    createDocument() {
      this.addFormDialog = true;
    },
    close() {
      this.addFormDialog = false;
    },
    // 点击新增周转筐
    submitAdd() {
      if (this.addForm.turnoverName == '') {
        this.$message.show({ text: '请输入周转筐名称', type: 'warning' });
        return false;
      }
      const reg = /(^([1-9]\d*)(.\d+)?$)|(^(0{1})(.\d+){1}$)/;
      if (this.addForm.turnoverSize && !reg.test(this.addForm.turnoverSize)) {
        this.$message.show({ text: '规格必须为正数', type: 'warning' });
        return false;
      }
      if (this.addForm.width || this.addForm.height || this.addForm.length) {
        if (!(this.addForm.width && this.addForm.height && this.addForm.length)) {
          this.$message.show({ text: '请完整填写长宽高', type: 'warning' });
          return false;
        }
        if (!reg.test(this.addForm.width)) {
          this.$message.show({ text: '宽度必须为正数', type: 'warning' });
          return false;
        }
        if (!reg.test(this.addForm.height)) {
          this.$message.show({ text: '高度必须为正数', type: 'warning' });
          return false;
        }
        if (!reg.test(this.addForm.length)) {
          this.$message.show({ text: '长度必须为正数', type: 'warning' });
          return false;
        }
      }

      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10026',
            OTYPE: 13,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            NAME: this.addForm.turnoverName,
            SPECIFICATION: this.addForm.turnoverSize,
            COLOR: this.addForm.turnoverColor,
            WIDTH: this.addForm.width,
            HEIGHT: this.addForm.height,
            LENGTH: this.addForm.length,
            SIZE_UNIT: 'cm',
          };
          http
            .post(params)
            .then((result) => {
              this.$message.show({ text: '新增周转筐成功', type: 'success' });
              this.addForm = {};
              document.body.style.cursor = 'default';
              this.addFormDialog = false;
              this.queryTurnover();
            })
            .catch((err) => {
              this.$message.show({ text: err, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
        }
      }
    },
    // 拉取周转筐数据
    queryTurnover() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result) {
          this.tableData = result;
        } else {
          this.tableData = [];
          this.total_count = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 删除
    del(row) {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 14,
        BASKET_ID: row.BASKET_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTurnover();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTurnover();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/turnoverList.vue